import React from 'react';
import ImageGallery from 'react-image-gallery';

const PostGallery = ({ block }) => {

    const images = block?.innerBlocks.map((innerBlock) => {
        const attributesJSON = innerBlock?.attributesJSON != null ? JSON.parse(innerBlock.attributesJSON) : null;
        /*         if (innerBlock?.attributes?.href != null && innerBlock?.attributes?.href?.length > 0) {
                    innerBlock.attributes.href.replaceAll("ü", "u%CC%88")
                } */
        return {
            original: attributesJSON?.href,
            thumbnail: attributesJSON?.href
        }
    });

    return (
        <ImageGallery items={images} />
    )
}

export default PostGallery
